module.exports = {"id":"176062","name":"Sacha Kljestan","rating":"75","photo":"./data/images/photos/0/176062.png","club":{"name":"Orlando City","logo":"./data/images/clubs/OrlandoCity.png"},"positions":["MOC","MC"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/SachaKljestan0.json
// module id = 3770
// module chunks = 0